var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoonClearLine = function SvgMoonClearLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#moon-clear-line_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.667 4a5.333 5.333 0 0 0 7.97 4.637 6.668 6.668 0 1 1-7.274-7.274A5.309 5.309 0 0 0 6.667 4Zm-4 4a5.333 5.333 0 0 0 9.97 2.637 6.667 6.667 0 0 1-7.275-7.275A5.337 5.337 0 0 0 2.668 8Zm9.442-6.473.558.14v.666l-.558.14a1.334 1.334 0 0 0-.97.97L11 4h-.666l-.14-.557a1.333 1.333 0 0 0-.97-.97l-.556-.14v-.666l.557-.14a1.333 1.333 0 0 0 .97-.97l.14-.557H11l.14.557a1.333 1.333 0 0 0 .97.97Zm3.334 3.334L16 5v.667l-.557.139a1.333 1.333 0 0 0-.97.97l-.14.557h-.666l-.14-.557a1.334 1.334 0 0 0-.97-.97L12 5.666V5l.557-.14a1.334 1.334 0 0 0 .97-.97l.14-.557h.666l.14.558a1.333 1.333 0 0 0 .97.97Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "moon-clear-line_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgMoonClearLine;